/** Site-wide constants for SEO, NAP, and CTAs */
export const SITE = {
  name: "Dexton Technology",
  url: "https://dextontechnology.com",
  email: "dextontechnology@gmail.com",
  phoneDisplay: "+91 878 068 7178",
  phoneTel: "+918780687178",
  whatsapp: "https://wa.me/918780687178?text=Hello%20Dexton%20Technology%2C%20I%20would%20like%20to%20discuss%20a%20project.",
  address: {
    street: "1067, Rajmahal Mall, Opp. Millenium Society, Dindoli",
    city: "Surat",
    region: "Gujarat",
    postalCode: "395001",
    country: "IN",
  },
  googleMapsEmbed:
    "https://www.google.com/maps?q=Rajmahal+Mall+Surat&output=embed",
  googleBusinessUrl: "https://www.google.com/maps/search/?api=1&query=Rajmahal+Mall+Surat+Gujarat",
  social: {
    instagram: "https://www.instagram.com/dextontechnology",
    linkedin: "https://www.linkedin.com/company/dextontechnology",
    twitter: "https://twitter.com/dextontechnology",
    facebook: "https://www.facebook.com/dextontechnology",
  },
  ogImage: "https://dextontechnology.com/dexton-logo-png.png",
};

export function absoluteUrl(path = "/") {
  if (!path.startsWith("/")) return `${SITE.url}/${path}`;
  return `${SITE.url}${path}`;
}
